export const getRandomColor = ({ saturation, lightness }) => {
  const colorAngle = Math.floor(Math.random() * 360);
  const color = `hsla(${colorAngle}deg, ${saturation}%, ${lightness}%, 1)`;
  return color;
};